/* eslint-disable */
export enum REPORT_ISSUE_MENU_OPTIONS {
  REQUEST_CREDIT = 'Request a credit or refund',
  FOLLOW_UP_CREDIT = 'Follow-up on a credit or refund',
  REPORT_TECHNICAL_ISSUE = 'Report a technical issue',
  FORMAL_TUTOR_COMPLAINT = 'Formal tutor complaint',
  OTHER = 'Other',
}
